"use client"
import React, {useEffect, useState} from "react";
import {
    BottomItems,
    GAME_KEY,
    HOME_KEY,
    STORE_KEY,
    TOOLS_KEY,
    VIDEO_KEY
} from "@/core/CONSTANTS";
import {useTranslations} from "use-intl";
import {usePathname, useRouter} from "next/navigation";
import Image from "next/image";
import {saveLastTab} from "@/core/services/localStorage.service";
import {Column} from "@/core/general/column.component";
import {Row} from "@/core/general/row.component";
import {BottomNavItems} from "@/core/menu/bottomNav.models";

export default function MenuBottomComponent() {

    const pathname=usePathname()
    const [tabValue, setTabValue] = useState<string>(pathname.replace("/","").trim()==""?HOME_KEY:(checkMainTabs()?pathname.replace("/","").trim():""));
    const t = useTranslations();
    const router = useRouter();
    const [mainTab, setMainTab] = useState(false);

    useEffect(()=>{
        setMainTab(checkMainTabs())
    },[pathname])

    function checkMainTabs():boolean{
        return pathname=="/"|| pathname.replace("/","").trim()==(HOME_KEY) || pathname.replace("/","").trim()==(STORE_KEY) || pathname.replace("/","").trim()==(TOOLS_KEY) || pathname.replace("/","").trim()==(VIDEO_KEY) || pathname.replace("/","").trim()==(GAME_KEY);
    }

    function onPositionChange(item: BottomNavItems) {
        setTabValue(item.valueKey);
        saveLastTab(item.valueKey)
        router.replace(`/${item.valueKey}`);
    }

    return(
        <Column className={"w-full block md:hidden"}>
            <Row className={`w-full left-0 items-center ${mainTab?"!h-16 fixed bottom-0":"hidden"} bgMain z-50`}>
                {BottomItems.map((item, index) => (
                    <Column key={index} className={'totalCenter p-1 pointer w-full'} onClick={() => onPositionChange(item)}>
                        <Image
                            fill={true}
                            sizes={'100%'}
                            className={`py-1.5 !relative mText ${
                                tabValue === item.valueKey ? 'bottomNavImageScale animation' : 'bottomNavImage'
                            }`}
                            alt={''}
                            src={tabValue === item.valueKey ? item.activeImage : item.image}
                        />
                        <div
                            className={`w-full text-center mb-3 ${
                                tabValue === item.valueKey ? 'mTextBlue text-sm' : 'mText text-xs'
                            }`}
                        >
                            {t(item.text)}
                        </div>
                    </Column>
                ))}
            </Row>
        </Column>
    )

}